/**
 * Exports data to CSV using papaparse
 * @param data Array of objects to export (keys will be column headers)
 * @param filename Name of the file to download (without .csv extension)
 * @param onComplete Optional callback when export completes
 */
export async function exportToCSV<T extends Record<string, any>>(
    data: T[],
    filename: string,
    onComplete?: () => void,
): Promise<void> {
    try {
        const Papa = await import('papaparse');
        const csv = Papa.unparse(data);

        // The '\uFEFF' (UTF-8 BOM) allows Excel to process international characters correctly
        const csvData = new Blob([ '\uFEFF' + csv ], { type: 'text/csv;charset=utf-8;' });

        const csvURL = URL.createObjectURL(csvData);
        const link = document.createElement('a');
        link.href = csvURL;
        link.download = `${filename}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Clean up the object URL
        URL.revokeObjectURL(csvURL);

        if (onComplete) {
            onComplete();
        }
    } catch (error) {
        if (onComplete) {
            onComplete();
        }
        throw error;
    }
}
